export const RECEIVERS_PAGE_MY_NAME = 'my';
export const RECEIVERS_PAGE_LIB_NAME = 'library';

export const receiversPagesData: any = {
  [RECEIVERS_PAGE_MY_NAME]: {
    name: RECEIVERS_PAGE_MY_NAME,
    title: 'My Receivers',
    itemStatuses: [1],
  },
  [RECEIVERS_PAGE_LIB_NAME]: {
    name: RECEIVERS_PAGE_LIB_NAME,
    title: 'Receiver Library',
    itemStatuses: [0, 1, 2, 3],
  },
};
